var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrokenLink = function SvgBrokenLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9714 14H27V12H37.9714C38.5395 12 39 12.4477 39 13C39 13.5523 38.5395 14 37.9714 14Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0286 14C10.4605 14 10 13.5523 10 13C10 12.4477 10.4605 12 11.0286 12H22V14H11.0286Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 4H35C33.3431 4 32 5.34315 32 7V10H34V7C34 6.44772 34.4477 6 35 6H47C47.5523 6 48 6.44772 48 7V19C48 19.5523 47.5523 20 47 20H35C34.4477 20 34 19.5523 34 19V16H32V19C32 20.6569 33.3431 22 35 22H47C48.6569 22 50 20.6569 50 19V7C50 5.34315 48.6569 4 47 4Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 19C15.3333 19.5523 14.8856 20 14.3333 20H3C2.44772 20 2 19.5523 2 19V7C2 6.44772 2.44772 6 3 6H14.3333C14.8856 6 15.3333 6.44772 15.3333 7V10H17.3333V7C17.3333 5.34315 15.9902 4 14.3333 4H3C1.34315 4 0 5.34315 0 7V19C0 20.6569 1.34315 22 3 22H14.3333C15.9902 22 17.3333 20.6569 17.3333 19V16H15.3333V19Z",
    fill: "#FC628F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.6818,
    y1: 8.26855,
    x2: 19.2551,
    y2: 4.06538,
    stroke: "#FC628F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 4.8534,
    y2: -1,
    transform: "matrix(-0.499999 0.866026 -0.866025 -0.500001 29.7002 3.56543)",
    stroke: "#FC628F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 8,
    x2: 25,
    y2: 1,
    stroke: "#FC628F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.1658,
    y1: 17.7314,
    x2: 30.5925,
    y2: 21.9346,
    stroke: "#FC628F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 19.2536,
    y1: 21.9346,
    x2: 21.6803,
    y2: 17.7314,
    stroke: "#FC628F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 18,
    x2: 25,
    y2: 25,
    stroke: "#FC628F",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrokenLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/broken-link.8012ef9af4925240bf0d83df1ceead2a.svg";